
//Navbar Box Shadow on Scroll + alert box

$(document).on('turbolinks:load', function()  {


 /******** get geolocation **************/
/// enable only in home page
current_url = window.location.pathname;

/******** favorite places **************/
var favoritePlacesStorageKey = 'kairos.favoritePlaces.v1';
var recentPlacesStorageKey = 'kairos.recentPlaces.v1';
var favoritePlacesLimit = 8;
var recentPlacesLimit = 5;
var myWeatherRequest = null;

function normalizeStoredPlaces(storedPlaces, limit) {
  if (!Array.isArray(storedPlaces)) {
    return [];
  }

  return storedPlaces.filter(function (place) {
    return place && place.id && place.name && place.url;
  }).slice(-limit);
}

function loadStoredPlaces(storageKey, limit) {
  try {
    return normalizeStoredPlaces(JSON.parse(window.localStorage.getItem(storageKey) || '[]'), limit);
  } catch (error) {
    return [];
  }
}

function saveStoredPlaces(storageKey, placesToSave) {
  try {
    window.localStorage.setItem(storageKey, JSON.stringify(placesToSave));
    return true;
  } catch (error) {
    return false;
  }
}

function loadFavoritePlaces() {
  return loadStoredPlaces(favoritePlacesStorageKey, favoritePlacesLimit);
}

function saveFavoritePlaces(favoritePlaces) {
  return saveStoredPlaces(favoritePlacesStorageKey, favoritePlaces);
}

function loadRecentPlaces() {
  return loadStoredPlaces(recentPlacesStorageKey, recentPlacesLimit);
}

function compactText(value) {
  return (value || '').toString().trim();
}

function saveRecentPlaces(recentPlaces) {
  return saveStoredPlaces(recentPlacesStorageKey, recentPlaces);
}

function rememberRecentPlace(place) {
  if (!place || !place.id || !place.name || !place.url) {
    return false;
  }

  var recentPlaces = loadRecentPlaces().filter(function (recentPlace) {
    return String(recentPlace.id) !== String(place.id);
  });
  recentPlaces.push(place);
  return saveRecentPlaces(recentPlaces.slice(-recentPlacesLimit));
}

function currentPlaceFromPage() {
  var $placeButton = $('.favorite-place-toggle').first();
  if (!$placeButton.length) {
    return null;
  }

  return {
    id: $placeButton.attr('data-place-id'),
    name: $placeButton.attr('data-place-name'),
    url: $placeButton.attr('data-place-url')
  };
}

function uniqueShortcutPlaces(placesToRender, excludedIds) {
  var seenIds = excludedIds || {};

  return placesToRender.filter(function (place) {
    if (!place || !place.id || !place.name || !place.url || seenIds[place.id]) {
      return false;
    }

    seenIds[place.id] = true;
    return true;
  });
}

function appendSearchShortcutSection($panel, title, placesToRender, groupName) {
  if (!placesToRender.length) {
    return;
  }

  var $section = $('<div>').addClass('search-shortcuts-section').addClass('is-' + groupName);
  $('<p>').addClass('search-shortcuts-title').text(title).appendTo($section);
  var $list = $('<ul>').addClass('search-shortcuts-list list-unstyled mb-0').appendTo($section);

  placesToRender.forEach(function (place) {
    $('<a>')
      .addClass('search-shortcut-link')
      .attr({
        href: place.url,
        'data-track': 'search_shortcut_click',
        'data-link-group': groupName,
        'data-place-id': place.id || '',
        'data-primary-signal': place.signal || ''
      })
      .text(place.name)
      .appendTo($('<li>').appendTo($list));
  });

  $section.appendTo($panel);
}

function searchGuideShortcuts($panel) {
  try {
    var guides = JSON.parse($panel.attr('data-guides') || '[]');
    return Array.isArray(guides) ? guides.filter(function (guide) {
      return guide && guide.name && guide.url;
    }) : [];
  } catch (_error) {
    return [];
  }
}

function renderSearchShortcuts() {
  var recentPlaces = loadRecentPlaces().slice().reverse();
  var favoritePlaces = loadFavoritePlaces().slice().reverse();

  $('[data-search-shortcuts]').each(function () {
    var $panel = $(this);
    var seenIds = {};
    var favoriteShortcuts = uniqueShortcutPlaces(favoritePlaces, seenIds);
    var recentShortcuts = uniqueShortcutPlaces(recentPlaces, seenIds);
    var guideShortcuts = searchGuideShortcuts($panel);

    $panel.empty();
    appendSearchShortcutSection($panel, $panel.attr('data-guides-title'), guideShortcuts, 'guides');
    appendSearchShortcutSection($panel, $panel.attr('data-favorites-title'), favoriteShortcuts, 'favorites');
    appendSearchShortcutSection($panel, $panel.attr('data-recent-title'), recentShortcuts, 'recent');

    if (!$panel.children().length) {
      $('<p>').addClass('search-shortcuts-empty mb-0').text($panel.attr('data-empty-text')).appendTo($panel);
    }
  });
}

function visibleSearchInputs($scope) {
  return $scope.find('input.search-input').filter(function () {
    var rect = this.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && $(this).is(':visible');
  });
}

function firstVisibleSearchInput($scope) {
  return visibleSearchInputs($scope).first();
}

function closeOtherSearchUi($input) {
  var $form = $input.closest('form');

  $('[data-search-shortcuts]').not($form.find('[data-search-shortcuts]')).addClass('d-none');
  $('input.search-input, input.search-input-widget').not($input).each(function () {
    var $otherInput = $(this);

    if (!$otherInput.data('ui-autocomplete')) {
      return;
    }

    try {
      $otherInput.autocomplete('close');
    } catch (_error) {}
  });
}

function openSearchShortcuts($input) {
  var inputElement = $input.get(0);

  if (!inputElement) {
    return;
  }

  var rect = inputElement.getBoundingClientRect();
  if (rect.width === 0 || rect.height === 0 || !$input.is(':visible')) {
    return;
  }

  var $form = $input.closest('form');
  var $panel = $form.find('[data-search-shortcuts]');

  if (!$panel.length || compactText($input.val()).length) {
    return;
  }

  renderSearchShortcuts();
  closeOtherSearchUi($input);
  $panel.removeClass('d-none');
}

function closeSearchShortcuts() {
  $('[data-search-shortcuts]').addClass('d-none');
}

function closeMobileSearchForm() {
  var $wrapper = $('.search-form-wrapper');

  $wrapper.removeClass('open');
  $('html').removeClass('search-form-open');
  $('#siteDisabledWithOpacity').removeClass('active');
  closeSearchShortcuts();

  $wrapper.find('input.search-input').each(function () {
    var $input = $(this);

    if (!$input.data('ui-autocomplete')) {
      return;
    }

    try {
      $input.autocomplete('close');
    } catch (_error) {}
  });
}

function renderMyWeather(favoritePlaces) {
  var $section = $('.my-weather');
  if (!$section.length) {
    return;
  }

  var $list = $section.find('.my-weather-list');
  var $loading = $section.find('.my-weather-loading');
  var $error = $section.find('.my-weather-error');
  var $defaultWeather = $('.home-default-weather');

  if (myWeatherRequest) {
    myWeatherRequest.abort();
    myWeatherRequest = null;
  }

  $list.empty();
  $list.removeAttr('data-count');
  $loading.addClass('d-none');
  $error.addClass('d-none');

  if (!favoritePlaces.length) {
    $section.addClass('d-none');
    $defaultWeather.removeClass('d-none');
    return;
  }

  $section.removeClass('d-none');
  $defaultWeather.addClass('d-none');
  $loading.removeClass('d-none');
  var request = $.getJSON($section.attr('data-forecast-url'), {
    ids: favoritePlaces.map(function (place) { return place.id; }).join(',')
  });
  myWeatherRequest = request;

  request.done(function (response) {
    var forecasts = response.forecasts || [];

    if (!forecasts.length) {
      $section.addClass('d-none');
      $defaultWeather.removeClass('d-none');
      return;
    }

    $list.attr('data-count', Math.min(forecasts.length, 4));

    forecasts.forEach(function (forecast) {
      var $card = $('<article>').addClass('my-weather-card');
      var $main = $('<a>').addClass('my-weather-card-main').attr('href', forecast.url).appendTo($card);
      var $top = $('<div>').addClass('my-weather-card-top').appendTo($main);
      $('<strong>').addClass('my-weather-place').text(forecast.name).appendTo($top);
      $('<span>').addClass('my-weather-temperature').text(forecast.temperature + '°').appendTo($top);

      var $body = $('<div>').addClass('my-weather-card-body').appendTo($main);
      $('<img>')
        .addClass('my-weather-icon')
        .attr({ src: forecast.icon_url, alt: forecast.description, width: 54, height: 54, loading: 'lazy' })
        .appendTo($body);
      var $summary = $('<div>').addClass('my-weather-summary').appendTo($body);
      $('<span>').addClass('my-weather-description').text(forecast.description).appendTo($summary);
      if (forecast.min_temperature !== null && forecast.max_temperature !== null) {
        $('<span>').addClass('my-weather-range').text(forecast.min_temperature + '° / ' + forecast.max_temperature + '°').appendTo($summary);
      }

      var $actions = $('<div>').addClass('my-weather-actions').appendTo($card);
      $('<a>').attr('href', forecast.hourly_url).text($list.attr('data-hourly-label')).appendTo($actions);
      $('<a>').attr('href', forecast.weekly_url).text($list.attr('data-weekly-label')).appendTo($actions);
      $('<button>')
        .attr({ type: 'button', 'data-place-id': forecast.id, 'aria-label': $list.attr('data-remove-label') })
        .addClass('favorite-place-remove my-weather-remove')
        .append($('<span>').addClass('favorite-star favorite-star-filled').attr('aria-hidden', 'true').text('★'))
        .appendTo($actions);
      $card.appendTo($list);
    });
  }).fail(function (_xhr, status) {
    if (status !== 'abort') {
      $section.addClass('d-none');
      $defaultWeather.removeClass('d-none');
    }
  }).always(function () {
    if (myWeatherRequest === request) {
      $loading.addClass('d-none');
      myWeatherRequest = null;
    }
  });
}

function renderFavoritePlaces() {
  var favoritePlaces = loadFavoritePlaces();
  var $list = $('.favorite-places-list');
  var $empty = $('.favorite-places-empty');
  var $count = $('.favorite-places-count');

  $list.empty();
  $empty.toggleClass('d-none', favoritePlaces.length > 0);
  $count.text(favoritePlaces.length || '').toggleClass('is-empty', favoritePlaces.length === 0);

  favoritePlaces.forEach(function (place) {
    var $item = $('<li>').addClass('favorite-places-item');
    $('<a>')
      .addClass('favorite-places-link')
      .attr('href', place.url)
      .text(place.name)
      .appendTo($item);
    $('<button>')
      .attr({
        type: 'button',
        'data-place-id': place.id,
        'aria-label': $('.favorite-places-dropdown').attr('data-remove-label') || 'Remove'
      })
      .addClass('favorite-place-remove')
      .append($('<i>').addClass('icon-cancel').attr('aria-hidden', 'true'))
      .appendTo($item);
    $item.appendTo($list);
  });

  $('.favorite-place-toggle').each(function () {
    var $button = $(this);
    var placeId = String($button.attr('data-place-id'));
    var isFavorite = favoritePlaces.some(function (place) {
      return String(place.id) === placeId;
    });
    var label = isFavorite ? $button.attr('data-remove-label') : $button.attr('data-add-label');

    $button
      .toggleClass('is-favorite', isFavorite)
      .attr('aria-pressed', isFavorite ? 'true' : 'false')
      .attr('title', label);
    $button.find('.favorite-star')
      .text(isFavorite ? '★' : '☆')
      .toggleClass('favorite-star-filled', isFavorite);
    $button.find('.favorite-place-toggle-label').text(label);
  });

  renderMyWeather(favoritePlaces);
  renderSearchShortcuts();
}

$(document)
  .off('click.forecastInternalLinks', '[data-track="forecast_internal_link"]')
  .on('click.forecastInternalLinks', '[data-track="forecast_internal_link"]', function () {
    if (typeof gtag !== 'function') {
      return;
    }

    var $link = $(this);
    gtag('event', 'forecast_internal_link_click', {
      link_group: $link.attr('data-link-group'),
      link_type: $link.attr('data-link-type'),
      page_type: $link.attr('data-page-type'),
      place_id: $link.attr('data-place-id'),
      link_text: compactText($link.text())
    });
  });

$(document)
  .off('click.decisionInternalLinks', '[data-track="decision_internal_link"]')
  .on('click.decisionInternalLinks', '[data-track="decision_internal_link"]', function () {
    if (typeof gtag !== 'function') {
      return;
    }

    var $link = $(this);
    gtag('event', 'decision_internal_link_click', {
      decision_type: $link.attr('data-link-type'),
      place_id: $link.attr('data-place-id'),
      link_text: compactText($link.text())
    });
  });

$(document)
  .off('click.homeEditorialHighlight', '[data-track="home_editorial_highlight_click"]')
  .on('click.homeEditorialHighlight', '[data-track="home_editorial_highlight_click"]', function () {
    if (typeof gtag !== 'function') {
      return;
    }

    var $link = $(this);
    gtag('event', 'home_editorial_highlight_click', {
      place_slug: $link.attr('data-place-slug'),
      page_type: $link.attr('data-page-type'),
      primary_signal: $link.attr('data-primary-signal'),
      editorial_score: $link.attr('data-editorial-score'),
      link_text: compactText($link.text())
    });
  });

$(document)
  .off('click.weatherTopicLive', '[data-track="weather_topic_live_click"]')
  .on('click.weatherTopicLive', '[data-track="weather_topic_live_click"]', function () {
    if (typeof gtag !== 'function') {
      return;
    }

    var $link = $(this);
    gtag('event', 'weather_topic_live_click', {
      place_slug: $link.attr('data-place-slug'),
      page_type: $link.attr('data-page-type'),
      primary_signal: $link.attr('data-primary-signal'),
      editorial_score: $link.attr('data-editorial-score'),
      link_text: compactText($link.text())
    });
  });

$(document)
  .off('click.forecastTopicGuide', '[data-track="forecast_topic_guide_click"]')
  .on('click.forecastTopicGuide', '[data-track="forecast_topic_guide_click"]', function () {
    if (typeof gtag !== 'function') {
      return;
    }

    var $link = $(this);
    gtag('event', 'forecast_topic_guide_click', {
      place_id: $link.attr('data-place-id'),
      page_type: $link.attr('data-page-type'),
      primary_signal: $link.attr('data-primary-signal'),
      link_text: compactText($link.text())
    });
  });

$(document)
  .off('focus.searchShortcuts click.searchShortcuts', 'input.search-input')
  .on('focus.searchShortcuts click.searchShortcuts', 'input.search-input', function () {
    closeOtherSearchUi($(this));
    $(this).closest('form').toggleClass('has-query', compactText($(this).val()).length > 0);
    openSearchShortcuts($(this));
  })
  .off('focusin.searchShortcutsForm click.searchShortcutsForm', '.search-shortcuts-form')
  .on('focusin.searchShortcutsForm click.searchShortcutsForm', '.search-shortcuts-form', function (event) {
    if ($(event.target).closest('[data-search-shortcuts], .search-shortcut-link').length) {
      return;
    }

    openSearchShortcuts(firstVisibleSearchInput($(this)));
  })
  .off('input.searchShortcuts', 'input.search-input')
  .on('input.searchShortcuts', 'input.search-input', function () {
    var $form = $(this).closest('form');
    var hasQuery = compactText($(this).val()).length > 0;
    $form.toggleClass('has-query', hasQuery);

    if (hasQuery) {
      closeOtherSearchUi($(this));
      $form.find('[data-search-shortcuts]').addClass('d-none');
    } else {
      openSearchShortcuts($(this));
    }
  })
  .off('click.searchShortcutTracking', '[data-track="search_shortcut_click"]')
  .on('click.searchShortcutTracking', '[data-track="search_shortcut_click"]', function () {
    var $link = $(this);

    if (typeof gtag === 'function') {
      gtag('event', 'search_shortcut_click', {
        link_group: $link.attr('data-link-group'),
        place_id: $link.attr('data-place-id'),
        primary_signal: $link.attr('data-primary-signal'),
        link_text: compactText($link.text())
      });
    }
  });

$(document)
  .off('click.searchShortcutsClose')
  .on('click.searchShortcutsClose', function (event) {
    if ($(event.target).closest('form, .ui-autocomplete').length) {
      return;
    }

    closeSearchShortcuts();
  });

$(document)
  .off('click.favoritesMenu', '.favorite-places-trigger')
  .on('click.favoritesMenu', '.favorite-places-trigger', function (event) {
    event.preventDefault();
    event.stopPropagation();
    var $trigger = $(this);
    var $menu = $trigger.siblings('.favorite-places-dropdown');
    var willOpen = !$menu.hasClass('show');

    $('.favorite-places-dropdown').removeClass('show');
    $('.favorite-places-trigger').attr('aria-expanded', 'false');
    $menu.toggleClass('show', willOpen);
    $trigger.attr('aria-expanded', willOpen ? 'true' : 'false');
  })
  .off('click.favorites', '.favorite-place-toggle')
  .on('click.favorites', '.favorite-place-toggle', function () {
    var $button = $(this);
    var placeId = String($button.attr('data-place-id'));
    var favoritePlaces = loadFavoritePlaces();
    var existingIndex = favoritePlaces.findIndex(function (place) {
      return String(place.id) === placeId;
    });

    if (existingIndex >= 0) {
      favoritePlaces.splice(existingIndex, 1);
    } else {
      favoritePlaces.push({
        id: placeId,
        name: $button.attr('data-place-name'),
        url: $button.attr('data-place-url')
      });
      favoritePlaces = favoritePlaces.slice(-favoritePlacesLimit);
    }

    if (saveFavoritePlaces(favoritePlaces)) {
      renderFavoritePlaces();
      if (typeof gtag === 'function') {
        gtag('event', existingIndex >= 0 ? 'remove_favorite_place' : 'add_favorite_place', {
          place_name: $button.attr('data-place-name')
        });
      }
    }
  })
  .off('click.favorites', '.favorite-place-remove')
  .on('click.favorites', '.favorite-place-remove', function (event) {
    event.preventDefault();
    event.stopPropagation();
    var placeId = String($(this).attr('data-place-id'));
    var favoritePlaces = loadFavoritePlaces().filter(function (place) {
      return String(place.id) !== placeId;
    });

    if (saveFavoritePlaces(favoritePlaces)) {
      renderFavoritePlaces();
    }
  });

$(document)
  .off('click.favoritesMenuClose')
  .on('click.favoritesMenuClose', function (event) {
    if ($(event.target).closest('.favorite-places-menu').length) {
      return;
    }

    $('.favorite-places-dropdown').removeClass('show');
    $('.favorite-places-trigger').attr('aria-expanded', 'false');
  });

renderFavoritePlaces();
if (rememberRecentPlace(currentPlaceFromPage())) {
  renderSearchShortcuts();
}

if (current_url == '/') {
getLocation()
}

function getLocation() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(showPosition);
  } else {
    alert("Geolocation is not supported by this browser.");
  }
}
function showPosition(position) {
  $.getJSON("/places/get_places", function (data) {
    nearest_city=NearestCity(position.coords.latitude, position.coords.longitude, data);
    if (window.location.hostname =='en.kairos.com.gr'){
        window.location.replace("/"+nearest_city.slug+'/daily-weather-forecast/0');
         
    }else{

       window.location.replace("/"+nearest_city.slug);
     }
  })
     
}

function Deg2Rad( deg ) {
  return deg * Math.PI / 180;
}

function PythagorasEquirectangular( lat1, lon1, lat2, lon2 ) {
  lat1 = Deg2Rad(lat1);
  lat2 = Deg2Rad(lat2);
  lon1 = Deg2Rad(lon1);
  lon2 = Deg2Rad(lon2);
  var R = 6371; // km
  var x = (lon2-lon1) * Math.cos((lat1+lat2)/2);
  var y = (lat2-lat1);
  var d = Math.sqrt(x*x + y*y) * R;
  return d;
}

function NearestCity(latitude, longitude, locations) {
  var mindif=99999;
  var closest;

  for (index = 0; index < locations.length; ++index) {
    var dif =  PythagorasEquirectangular(latitude, longitude, locations[ index ].lat, locations[ index ].lng);
    if ( dif < mindif ) {
      closest=index;
      mindif = dif;
    }
  }
  // return the nearest location
  var closestLocation = (locations[ closest ]);
  return closestLocation;
}
   




  
  //if($('.header').length>0){

    var navbar = $('.navbar-container');

    var logo=$('.image-logo')
    var searh_form_menu=$('.search-form-menu')
    var alert_box = $('.bg-alert');
    var isHomePageNav = navbar.hasClass('home-page-nav');

    if($(window).width() < 767){
      searh_form_menu.addClass('d-sm-block ')        
    }

    var navIsScrolled = navbar.hasClass('scrolled-nav');
    var alertIsAtBottom = false;
    var tickingScroll = false;

    function updateHeaderOnScroll(){
        if(isHomePageNav){
          turn_to_white(navbar, logo, searh_form_menu)
          navIsScrolled = true;
          return;
        }

        var scrollTop = $(window).scrollTop();
        var shouldUseImageBg = scrollTop <= 50 && $('.navbar-collapse.show').length==0;

        if(shouldUseImageBg && navIsScrolled){
          turn_to_image_bg(navbar, logo,searh_form_menu)
          navIsScrolled = false;
        } else if(!shouldUseImageBg && !navIsScrolled) {
          turn_to_white(navbar, logo,searh_form_menu)
          navIsScrolled = true;
        }

        if(alert_box.length){
          var shouldStickAlert = scrollTop + $(window).height() >= $(document).height() - 1;
          if(shouldStickAlert !== alertIsAtBottom){
            alert_box.toggleClass('to-bottom', shouldStickAlert)
            alertIsAtBottom = shouldStickAlert;
          }
        }
    }

    $(window).on('scroll.headerPerformance', function(){
      if(tickingScroll){
        return;
      }

      tickingScroll = true;
      window.requestAnimationFrame(function(){
        updateHeaderOnScroll();
        tickingScroll = false;
      });
    });

    updateHeaderOnScroll();

    $("#navbar-toggler-id").click(function() {
      if($(window).scrollTop() <= 50){
        if($('.scrolled-nav').length==0){
          turn_to_white(navbar, logo,searh_form_menu)
          navIsScrolled = true;
        }
        else {
          turn_to_image_bg(navbar, logo,searh_form_menu)
          navIsScrolled = false;

        }
      }else{

      }
  
      })

/*  }else{
    var navbar = $('.navbar-container');
    $(window).scroll(function(){
        if($(window).scrollTop() <= 40){
          navbar.css('box-shadow', 'none');
           navbar.css('background-color', 'transparent');

        } else {
          navbar.css('box-shadow', '0px 10px 20px rgba(0, 0, 0, 0.4)'); 
           navbar.css('background-color', 'white');

        }
    });  
  }*/

  function turn_to_image_bg(navbar, logo,searh_form_menu){

    navbar.removeClass('scrolled-nav')
    if($('.header').length>0){
        logo.attr("src","/assets/logo_w.svg");
      
        if($(window).width() > 767){
          searh_form_menu.removeClass('d-sm-block ')     
        }  
      }
  }
  function turn_to_white(navbar, logo,searh_form_menu){
     navbar.addClass('scrolled-nav')
     if($('.header').length>0){
        logo.attr("src","/assets/logo_d.svg");
      
        if($(window).width() > 767){
          searh_form_menu.addClass('d-sm-block ')        
        }
      }
  }


function setOffcanvasAccessibility($offcanvas, isOpen) {
    $offcanvas.attr('aria-hidden', isOpen ? 'false' : 'true');

    if (isOpen) {
      $offcanvas.removeAttr('inert');
    } else {
      $offcanvas.attr('inert', '');
    }
}

function openOffcanvas($offcanvas, $trigger) {
    $offcanvas.addClass("show");
    setOffcanvasAccessibility($offcanvas, true);
    $('body').addClass("offcanvas-active");
    $(".screen-overlay").addClass("show");
    $('#siteDisabledWithOpacity').addClass('active');
    if ($trigger && $trigger.length) {
      $trigger.attr('aria-expanded', 'true');
    }
}

function closeOffcanvas() {
    $(".screen-overlay").removeClass("show");
    $(".mobile-offcanvas").removeClass("show");
    $(".mobile-offcanvas").each(function () {
      setOffcanvasAccessibility($(this), false);
    });
    $("body").removeClass("offcanvas-active");
    $('[data-trigger]').attr('aria-expanded', 'false');
    $('#siteDisabledWithOpacity').removeClass('active');
}

function injectOffcanvasMenu($offcanvas, html) {
    var parsedHtml = $.parseHTML(html, document, true);
    var $loaded = $(parsedHtml);
    var content = $loaded.filter('#navbarSupportedContent').html() || $loaded.find('#navbarSupportedContent').html() || html;
    $offcanvas.html(content);
    $offcanvas.attr('data-menu-loaded', 'true');
    renderFavoritePlaces();
}

$("[data-trigger]").on("click", function(e){
    e.preventDefault();
    e.stopPropagation();
    var $trigger = $(this);
    var offcanvas_id =  $trigger.attr('data-trigger');
    var $offcanvas = $(offcanvas_id);
    var menuUrl = $trigger.attr('data-menu-url');

    if (!$offcanvas.length) {
      return;
    }

    if ($offcanvas.hasClass("show")) {
      closeOffcanvas();
      return;
    }

    if (menuUrl && $offcanvas.attr('data-menu-loaded') !== 'true') {
      $trigger.prop('disabled', true).addClass('is-loading');
      $.get(menuUrl)
        .done(function (html) {
          injectOffcanvasMenu($offcanvas, html);
          openOffcanvas($offcanvas, $trigger);
        })
        .fail(function () {
          window.location.href = menuUrl;
        })
        .always(function () {
          $trigger.prop('disabled', false).removeClass('is-loading');
        });
      return;
    }

    openOffcanvas($offcanvas, $trigger);

}); 

$(document).on("click", ".btn-close, .screen-overlay", function(e){
    closeOffcanvas();
}); 

// Prevent closing from click inside dropdown
$(document).on('click', '.dropdown-menu', function (e) {
   e.stopPropagation();
});

$(document)
  .off('click.headerDropdowns', '.mobile-offcanvas .dropdown-toggle:not(.favorite-places-trigger)')
  .on('click.headerDropdowns', '.mobile-offcanvas .dropdown-toggle:not(.favorite-places-trigger)', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $trigger = $(this);
    var $menu = $trigger.next('.dropdown-menu');

    if (!$menu.length) {
      $menu = $trigger.parent().children('.dropdown-menu').first();
    }

    if (!$menu.length) {
      return;
    }

    var willOpen = !$menu.hasClass('show');
    var isNested = $trigger.closest('.dropdown-menu').length > 0;

    if (isNested) {
      $trigger.closest('li').siblings().find('> .dropdown-menu.show').removeClass('show');
      $trigger.closest('li').siblings().find('> .dropdown-toggle[aria-expanded="true"]').attr('aria-expanded', 'false');
    } else {
      $('.mobile-offcanvas > .navbar-nav .dropdown-menu.show').not($menu).removeClass('show');
      $('.mobile-offcanvas > .navbar-nav .dropdown-toggle[aria-expanded="true"]').not($trigger).attr('aria-expanded', 'false');
    }

    $menu.toggleClass('show', willOpen);
    $trigger.attr('aria-expanded', willOpen ? 'true' : 'false');
  });

$(document)
  .off('click.headerDropdownsClose')
  .on('click.headerDropdownsClose', function (event) {
    if ($(event.target).closest('.mobile-offcanvas').length) {
      return;
    }

    $('.mobile-offcanvas .dropdown-menu.show').removeClass('show');
    $('.mobile-offcanvas .dropdown-toggle[aria-expanded="true"]').attr('aria-expanded', 'false');
  });

/***** Search toggle ******/

  $(document)
    .off('click.mobileSearchOpen', '[data-toggle=search-form]')
    .on('click.mobileSearchOpen', '[data-toggle=search-form]', function(event) {
    event.preventDefault();
    var $homeHeroSearch = $('#home_landing_search input.search-input').first();

    if ($homeHeroSearch.length) {
      event.stopImmediatePropagation();
      closeMobileSearchForm();
      $('html, body').animate({ scrollTop: Math.max($homeHeroSearch.offset().top - 96, 0) }, 180);
      window.setTimeout(function () {
        $homeHeroSearch.trigger('focus');
        $homeHeroSearch[0].focus();
        openSearchShortcuts($homeHeroSearch);
      }, 190);
      return;
    }

    var $wrapper = $('.search-form-wrapper');
    var willOpen = !$wrapper.hasClass('open');

    $wrapper.toggleClass('open', willOpen);
    $('html').toggleClass('search-form-open', willOpen);
    $('#siteDisabledWithOpacity').toggleClass('active', willOpen);

    if (willOpen) {
      window.setTimeout(function () {
        var $input = firstVisibleSearchInput($wrapper);
        $input.trigger('focus');
        if ($input.length) {
          $input[0].focus();
        }
      }, 0);
    } else {
      closeMobileSearchForm();
    }
  })
    .off('click.mobileSearchClose', '[data-toggle=search-form-close], .search-close')
    .on('click.mobileSearchClose', '[data-toggle=search-form-close], .search-close', function(event) {
      event.preventDefault();
      closeMobileSearchForm();
    })
    .off('keydown.mobileSearchClose')
    .on('keydown.mobileSearchClose', function(event) {
      if (event.key === 'Escape' && $('.search-form-wrapper').hasClass('open')) {
        closeMobileSearchForm();
      }
    });

// make it as accordion for smaller screens

if ($(window).width() < 992) {
  $('.dropdown-menu .dropdown-toggle').click(function(e){
    if ($(this).closest('.mobile-offcanvas').length) {
      return;
    }

    e.preventDefault();
    if($(this).next('.submenu').length){
      $(this).next('.submenu').toggle();
    }
    $('.dropdown').on('hide.bs.dropdown', function () {
     $(this).find('.submenu').hide();
    })

 
    if($(this).next('.leftsubmenu').length){
      $(this).next('.leftsubmenu').toggle();
    }
    $('.dropdown').on('hide.bs.dropdown', function () {
     $(this).find('.leftsubmenu').hide();
    })

  });
   $( ".has-megasubmenu a" ).on( "click", function(e) {
    nextEl = this.nextElementSibling;
    if(nextEl && nextEl.classList.contains('megasubmenu')) {  
      // prevent opening link if link needs to open dropdown
      e.preventDefault();

      if(nextEl.style.display == 'block'){
        nextEl.style.display = 'none';
      } else {
        nextEl.style.display = 'block';
      }

    }    
    
  });
}

$('.nav-item').on('show.bs.dropdown', function () {
  $('#siteDisabledWithOpacity').addClass('active');
})
$('#siteDisabledWithOpacity').off('click.globalOverlayClose').on('click.globalOverlayClose', function () {
  $('#siteDisabledWithOpacity').removeClass('active');
    closeOffcanvas();
    closeMobileSearchForm();
})

 
/************* AutoComplete **********/

var places = [];
var placesRequest = null;
var placesUrl = $('meta[name="places-autocomplete-url"]').attr('content');

function loadAutocompletePlaces() {
  if (places.length) {
    return $.Deferred().resolve(places).promise();
  }

  if (placesRequest) {
    return placesRequest;
  }

  if (!placesUrl) {
    return $.Deferred().resolve([]).promise();
  }

  placesRequest = $.getJSON(placesUrl).then(function (data) {
    places = data || [];
    return places;
  }, function () {
    placesRequest = null;
    return [];
  });

  return placesRequest;
}
var accentMap = {
      "ά": "α",
      "ό": "ο",
      "έ": "ε",
      "ή": "η",
      "ί": "ι",
      "ύ": "υ",
      "ϋ": "υ",         
      "ΰ": "υ",         
      "ώ": "ω",
      "ϊ": "ι",
      "ΐ": "ι",
      "Ά":"Α",
      "Ί":"Ι",
      "Ό": "ο",
      "Έ": "ε",
      "Ή": "η"

   };

var normalize = function( term ) {
      var ret = "";
      for ( var i = 0; i < term.length; i++ ) {
        ret += accentMap[ term.charAt(i) ] || term.charAt(i);
      }
      return ret;
    };
    var autocompleteInitialized = false;
    var autocompletePromise = null;

    function initializeAutocomplete() {
      if (autocompleteInitialized) {
        return;
      }

      autocompleteInitialized = true;

	    var autocompleteOptions = {
      source: function( request, response ) {
        loadAutocompletePlaces().then(function (loadedPlaces) {
          var matcher = new RegExp( $.ui.autocomplete.escapeRegex( request.term ), "i" );
          response( $.grep( loadedPlaces, function( value ) {

            value = value.label || value.value || value;
            return matcher.test( value ) || matcher.test( normalize( value ) );
          }) );
        });
      },
      search: function() {
        closeOtherSearchUi($(this));
      },
      open: function() {
        closeOtherSearchUi($(this));
        $(this).closest('form').find('[data-search-shortcuts]').addClass('d-none');
      },
	      select: function( event, ui ) {
	         $(this).val(ui.item.value)
	       if (ui.item.url) {
	         window.location.href = ui.item.url
	         return false
	       }
	       $(this).closest("form").submit()
	       if (typeof gtag === 'function') {
	         gtag('event', 'search', {
	            search_term: ui.item.value
	         });
	       }
	      }
    };

    function titleizeAutocompleteLabel(label) {
      return (label || '').toString().toLowerCase().replace(/(^|[\s(.-])([a-zα-ωάέήίόύώϊϋΐΰ])/g, function (_, prefix, letter) {
        return prefix + letter.toUpperCase();
      });
    }

    function styleAutocompleteMenu($inputs) {
      $inputs.each(function () {
        var $input = $(this);
        var autocomplete = $input.data('ui-autocomplete');
        if (!autocomplete) {
          return;
        }

        $input.autocomplete('option', 'appendTo', $input.closest('form'));
        autocomplete._resizeMenu = function () {
          var maxWidth = Math.max(240, $(window).width() - 24);
          var inputWidth = this.element.outerWidth();
          var menuWidth = Math.max(inputWidth, Math.min(360, maxWidth));
          this.menu.element.outerWidth(Math.min(menuWidth, maxWidth));
        };

        autocomplete._renderItem = function (ul, item) {
          var typeClass = item.type === 'regional_unit' ? 'is-region' : (item.type === 'weather_topic' ? 'is-guide' : 'is-place');
          var optionWrapper = $('<div>').addClass('ui-menu-item-wrapper');
          var option = $('<div>').addClass('autocomplete-option').addClass(typeClass);
          $('<span>').addClass('autocomplete-option-marker').appendTo(option);
          var content = $('<span>').addClass('autocomplete-option-content').appendTo(option);
          $('<span>').addClass('autocomplete-option-label').text(titleizeAutocompleteLabel(item.label || item.value)).appendTo(content);

          if (item.badge) {
            $('<span>').addClass('autocomplete-option-badge').text(item.badge).appendTo(option);
          }

          return $('<li>').append(optionWrapper.append(option)).appendTo(ul);
        };
      });
    }

    styleAutocompleteMenu($('input.search-input').autocomplete(autocompleteOptions));
styleAutocompleteMenu($('input.search-input-widget').autocomplete({
      source: function( request, response ) {
        loadAutocompletePlaces().then(function (loadedPlaces) {
          var matcher = new RegExp( $.ui.autocomplete.escapeRegex( request.term ), "i" );
       
          response( $.grep( loadedPlaces, function( value ) {

            value = value.label || value.value || value;
            return matcher.test( value ) || matcher.test( normalize( value ) );
          }) );
        });
      },
      search: function() {
        closeOtherSearchUi($(this));
      },
      open: function() {
        closeOtherSearchUi($(this));
      },
      select: function( event, ui ) {
         $(this).val(ui.item.value)
       /**$(this).closest("form").submit()
       gtag('event', 'search', {
          search_term: ui.item.value
        });*/
      }
    }));
    }

    function loadAutocomplete() {
      if (autocompletePromise) {
        return autocompletePromise;
      }

      autocompletePromise = import(
        /* webpackChunkName: "places-autocomplete" */
        'jquery-ui/ui/widgets/autocomplete'
      ).then(function () {
        initializeAutocomplete();
      });

      return autocompletePromise;
    }

    $('input.search-input, input.search-input-widget').one('focus.autocomplete', function () {
      var input = this;
      loadAutocompletePlaces();
      loadAutocomplete().then(function () {
        var $input = $(input);
        if ($input.val()) {
          $input.autocomplete('search', $input.val());
        }
      });
    });

/*
$('.search-input').autocomplete({
       // source: [places],
        source: [function( request, response ) {
          var matcher = new RegExp( request.term , "i" );
          console.log(matcher)
          response($.grep(places, function(value) {
            console.log(normalize(value))
              console.log (matcher.test(value) +"  " + matcher.test(normalize(value)))
              return matcher.test(value) || matcher.test(normalize(value));
            }) 
          );
        }],
        showHint:false
        //,
       // accents:true,
        //replaceAccentsForRemote: true
    }
).on('selected.xdsoft',function(e,datum){
  console.log($(this).closest("form"));
  console.log(datum);
 $(this).closest("form").submit()
 
});

*/
})
